import type * as React from 'react';

import type * as api from '@gitbook/api-client';

import { ContentIcon, type ContentIconProps } from '../Content';

export type SpaceIconProps = Omit<ContentIconProps, 'content'> & {
    space: api.Space;
    size?: number;
};

/**
 * Render the icon associated with a space.
 */
export function SpaceIcon(props: SpaceIconProps): React.ReactElement {
    const { space, ...iconProps } = props;
    return <ContentIcon content={space} {...iconProps} />;
}
